import Cookies from "js-cookie";
// import baseQueries from "./provideBaseQueriesOnFilterUrl";
const filterOpposites = {
  genders: "genders[]",
  "genders[]": "genders[]",
  "brands[]": "brands[]",
  brand: "brands[]",
  groups: "groups[]",
  "groups[]": "groups[]",
  authors: "authors[]",
  "authors[]": "authors[]",
  notes: "notes[]",
  "notes[]": "notes[]",
  part_of_day: "part_of_day",
  season: "season",
  min_price: "min_price",
  max_price: "max_price",
  currentBrand: "currentBrand",
  categories: "categories",
  order_by: "order_by",
  direction: "direction",
  // stickers: "stickers",

  page: "page",
  keyword: "keyword",
};

const filterUrlsAccordingToSearchParams = (searchParams, isClient = false) => {
  const params = new URLSearchParams();

  (isClient
    ? Array.from(searchParams.entries())
    : Object.entries(searchParams)
  ).forEach(([key, value]) => {
    if (filterOpposites[key]) {
      if (Array.isArray(value)) {
        value.forEach((v) => params.append(key, v));
      } else {
        params.set(filterOpposites[key], value);
        if (key === "brand") {
          params.set("brand", value);
        }
      }
    }

    if (["per_page", "page", "search_text", "sort_order"].includes(key)) {
      params.set(key, value);
      if (key === "sort_order") {
        params.set("sort_by", `title_${Cookies.get("NEXT_LOCALE") || "az"}`); // bu yenidi
      }
    }
  });

  // return params;
  return decodeURIComponent(params.toString());
};

export { filterUrlsAccordingToSearchParams };
